var _metadata, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataRepositoryAzureStorageAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9,
    x2: 9,
    y1: 15.799,
    y2: 5.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32bedd",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32d4f5",
    offset: 0.775
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6017 0 0 2.6017 .58467 -.44251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.544 5.316h16.912v9.918a0.565 0.565 0 0 1-0.565 0.565h-15.782a0.565 0.565 0 0 1-0.565-0.565z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.112 2.2h15.776a0.565 0.565 0 0 1 0.565 0.565v2.55h-16.906v-2.549a0.565 0.565 0 0 1 0.565-0.566z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.528 7.347h-4.144a0.228 0.228 0 0 1-0.124-0.037l-1.183-0.787a0.218 0.218 0 0 0-0.123-0.038h-3.482a0.222 0.222 0 0 0-0.222 0.222v7.315a0.221 0.221 0 0 0 0.222 0.222h9.056a0.221 0.221 0 0 0 0.222-0.222v-6.453a0.222 0.222 0 0 0-0.222-0.222z",
    fill: "#f78d1e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.114,
    y: 6.91,
    width: 2.159,
    height: 0.432,
    rx: 0.091,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.114,
    y: 6.91,
    width: 0.432,
    height: 0.432,
    rx: 0.062,
    fill: "#d15900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.528 7.337h-4.551a0.219 0.219 0 0 0-0.157 0.063l-0.732 0.731a0.22 0.22 0 0 1-0.157 0.066h-3.459a0.221 0.221 0 0 0-0.222 0.221v5.591a0.221 0.221 0 0 0 0.222 0.222h9.056a0.221 0.221 0 0 0 0.222-0.222v-6.451a0.221 0.221 0 0 0-0.222-0.221z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRepositoryAzureStorageAccount);
export default __webpack_public_path__ + "static/media/dataRepositoryAzureStorageAccount.97b2b7758fef6cc6c05ea544c9b693b2.svg";
export { ForwardRef as ReactComponent };